export default function(engine) {

    this._options.engine = engine;

    return this;
};
